import script from "./Errors.vue?vue&type=script&setup=true&lang=js"
export * from "./Errors.vue?vue&type=script&setup=true&lang=js"

import "./Errors.vue?vue&type=style&index=0&id=51eb74c9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51eb74c9"]])

export default __exports__